module.exports = __webpack_public_path__ + "static/stephanie-hamon-a5acdb2e93438efba090c6bb9eb4117e.png";